import { REQUEST_SELECT_DEALER } from "@actions/actionTypes";

export function setDealer(code) {
    return dispatch => {
        dispatch({type: REQUEST_SELECT_DEALER, code})
    }
}